import React from 'react'
import { motion } from 'framer-motion'

interface SkipLinksProps {
  links?: Array<{
    href: string
    label: string
  }>
}

export const SkipLinks: React.FC<SkipLinksProps> = ({ 
  links = [
    { href: '#main-content', label: 'Skip to main content' },
    { href: '#main-navigation', label: 'Skip to navigation' }
  ]
}) => {
  return (
    <div className="sr-only focus-within:not-sr-only">
      <div className="fixed top-0 left-0 right-0 z-[9999] bg-white border-b-2 border-blue-600 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 py-2">
          <nav aria-label="Skip navigation links">
            <ul className="flex gap-4">
              {links.map((link, index) => (
                <li key={index}>
                  <motion.a
                    href={link.href}
                    className="inline-block px-4 py-2 bg-blue-600 text-white font-medium rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 hover:bg-blue-700 transition-colors"
                    whileFocus={{ scale: 1.05 }}
                    onClick={(e) => {
                      e.preventDefault()
                      const target = document.querySelector(link.href)
                      if (target) {
                        (target as HTMLElement).focus()
                        target.scrollIntoView({ behavior: 'smooth' })
                      }
                    }}
                  >
                    {link.label}
                  </motion.a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  )
}